var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        {
          staticClass: "table-operator",
          staticStyle: { "margin-bottom": "12px" },
        },
        [
          _c("h-select", {
            staticStyle: { width: "150px" },
            attrs: { placeholder: "支付渠道", options: _vm.channelOpts },
            on: { change: _vm.load },
            model: {
              value: _vm.query.payChannel,
              callback: function ($$v) {
                _vm.$set(_vm.query, "payChannel", $$v)
              },
              expression: "query.payChannel",
            },
          }),
          _c("a-input-search", {
            staticStyle: { width: "200px", "margin-left": "8px" },
            attrs: { placeholder: "商户号 mch_id" },
            on: { search: _vm.load },
            model: {
              value: _vm.query.mchId,
              callback: function ($$v) {
                _vm.$set(_vm.query, "mchId", $$v)
              },
              expression: "query.mchId",
            },
          }),
          _c("a-input-search", {
            staticStyle: { width: "220px", "margin-left": "8px" },
            attrs: { placeholder: "商户订单号 out_trade_no" },
            on: { search: _vm.load },
            model: {
              value: _vm.query.outTradeNo,
              callback: function ($$v) {
                _vm.$set(_vm.query, "outTradeNo", $$v)
              },
              expression: "query.outTradeNo",
            },
          }),
          _c("h-select", {
            staticStyle: { width: "140px", "margin-left": "8px" },
            attrs: { placeholder: "接收状态", options: _vm.statusOpts },
            on: { change: _vm.load },
            model: {
              value: _vm.query.status,
              callback: function ($$v) {
                _vm.$set(_vm.query, "status", $$v)
              },
              expression: "query.status",
            },
          }),
          _c("h-select", {
            staticStyle: { width: "160px", "margin-left": "8px" },
            attrs: { placeholder: "业务处理状态", options: _vm.procOpts },
            on: { change: _vm.load },
            model: {
              value: _vm.query.processStatus,
              callback: function ($$v) {
                _vm.$set(_vm.query, "processStatus", $$v)
              },
              expression: "query.processStatus",
            },
          }),
          _c("a-range-picker", {
            staticStyle: { "margin-left": "8px" },
            on: { change: _vm.load },
            model: {
              value: _vm.query.dateRage,
              callback: function ($$v) {
                _vm.$set(_vm.query, "dateRage", $$v)
              },
              expression: "query.dateRage",
            },
          }),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { type: "primary", icon: "search" },
              on: { click: _vm.load },
            },
            [_vm._v("查询")]
          ),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { icon: "sync" },
              on: { click: _vm.load },
            },
            [_vm._v("刷新")]
          ),
        ],
        1
      ),
      _c("a-table", {
        attrs: {
          bordered: "",
          size: "middle",
          rowKey: "id",
          columns: _vm.cols,
          dataSource: _vm.rows,
          loading: _vm.loading,
          pagination: _vm.pag,
        },
        on: {
          change: (p) => {
            _vm.pag.current = p.current
            _vm.pag.pageSize = p.pageSize
            _vm.load()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "ch_slot",
            fn: function (t) {
              return [
                t
                  ? _c("a-tag", [_vm._v(_vm._s(t))])
                  : _c("span", { staticClass: "muted" }, [_vm._v("—")]),
              ]
            },
          },
          {
            key: "st_slot",
            fn: function (t) {
              return [
                t === "SUCCESS"
                  ? _c("a-tag", { attrs: { color: "green" } }, [
                      _vm._v("接收成功"),
                    ])
                  : t === "SIGN_FAIL"
                  ? _c("a-tag", { attrs: { color: "red" } }, [
                      _vm._v("验签失败"),
                    ])
                  : t === "DUP"
                  ? _c("a-tag", { attrs: { color: "orange" } }, [
                      _vm._v("重复请求"),
                    ])
                  : t === "FAIL"
                  ? _c("a-tag", { attrs: { color: "red" } }, [
                      _vm._v("格式非法"),
                    ])
                  : _c("span", { staticClass: "muted" }, [
                      _vm._v(_vm._s(t || "—")),
                    ]),
              ]
            },
          },
          {
            key: "pr_slot",
            fn: function (t) {
              return [
                t === "CREATED"
                  ? _c("a-tag", { attrs: { color: "blue" } }, [
                      _vm._v("已入队"),
                    ])
                  : t === "DONE"
                  ? _c("a-tag", { attrs: { color: "green" } }, [
                      _vm._v("已生成转账单"),
                    ])
                  : t === "VOUCHERED"
                  ? _c("a-tag", { attrs: { color: "purple" } }, [
                      _vm._v("已生成凭证"),
                    ])
                  : t === "IGNORED"
                  ? _c("a-tag", { attrs: { color: "default" } }, [
                      _vm._v("已忽略"),
                    ])
                  : t === "ERROR"
                  ? _c("a-tag", { attrs: { color: "red" } }, [
                      _vm._v("处理异常"),
                    ])
                  : _c("span", { staticClass: "muted" }, [
                      _vm._v(_vm._s(t || "—")),
                    ]),
              ]
            },
          },
          {
            key: "amt_slot",
            fn: function (t) {
              return [
                _c("span", { staticClass: "mono" }, [
                  _vm._v(_vm._s(t == null ? "—" : Number(t).toFixed(2))),
                ]),
              ]
            },
          },
          {
            key: "action",
            fn: function (t, r) {
              return [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.openDetail(r)
                      },
                    },
                  },
                  [_vm._v("详情")]
                ),
                _c("a-divider", { attrs: { type: "vertical" } }),
                r.process_status === "ERROR" || r.process_status === "CREATED"
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.retry(r)
                          },
                        },
                      },
                      [_vm._v("重试处理")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c(
        "a-drawer",
        {
          attrs: {
            title: "回调详情",
            placement: "right",
            width: 680,
            visible: _vm.drawer,
          },
          on: {
            close: function ($event) {
              _vm.drawer = false
            },
          },
        },
        [
          _vm.detail
            ? _c(
                "a-descriptions",
                { attrs: { bordered: "", size: "small", column: 1 } },
                [
                  _c("a-descriptions-item", { attrs: { label: "回调时间" } }, [
                    _vm._v(_vm._s(_vm.detail.notify_time)),
                  ]),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: "租户ID / 支付渠道" } },
                    [
                      _vm._v(
                        _vm._s(_vm.detail.tenant_id) +
                          " / " +
                          _vm._s(_vm.detail.pay_channel)
                      ),
                    ]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: "商户号 / AppId" } },
                    [
                      _vm._v(
                        _vm._s(_vm.detail.mch_id) +
                          " / " +
                          _vm._s(_vm.detail.app_id || "—")
                      ),
                    ]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: "商户订单号" } },
                    [_vm._v(_vm._s(_vm.detail.out_trade_no))]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: "三方交易号 transaction_id" } },
                    [_vm._v(_vm._s(_vm.detail.transaction_id || "—"))]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: "金额(元) / 手续费" } },
                    [
                      _vm._v(
                        _vm._s(Number(_vm.detail.amount || 0).toFixed(2)) +
                          " / " +
                          _vm._s(
                            _vm.detail.fee_amount == null
                              ? "—"
                              : Number(_vm.detail.fee_amount).toFixed(2)
                          )
                      ),
                    ]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: "接收状态 / 幂等键" } },
                    [
                      _vm._v(
                        _vm._s(_vm.detail.status) +
                          " / " +
                          _vm._s(_vm.detail.idempotency_key || "—")
                      ),
                    ]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: "业务处理 / 关联转账单 / 凭证" } },
                    [
                      _vm._v(
                        _vm._s(_vm.detail.process_status) +
                          " / " +
                          _vm._s(_vm.detail.account_head_id || "—") +
                          " / " +
                          _vm._s(_vm.detail.voucher_id || "—")
                      ),
                    ]
                  ),
                  _vm.detail.error_msg
                    ? _c(
                        "a-descriptions-item",
                        { attrs: { label: "错误信息" } },
                        [
                          _c("span", { staticClass: "text-red" }, [
                            _vm._v(_vm._s(_vm.detail.error_msg)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: "原始报文(raw_body)" } },
                    [
                      _c(
                        "textarea",
                        {
                          staticStyle: {
                            width: "100%",
                            "font-family": "Consolas,monospace",
                            "font-size": "12px",
                          },
                          attrs: { readonly: "", rows: "6" },
                        },
                        [_vm._v(_vm._s(_vm.detail.raw_body || ""))]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }